import { defineStore } from "pinia";
import { useGetData } from "~/composables/useGetData";
import { usePostDataFileStream } from "~/composables/usePostDataFileStream";


export const useOrdiniVenditaStore = defineStore("ordiniVenditaStore", {
  state: () => ({
    ordiniVendita: [],
    caricandoOrdiniVendita: false,
    errorMessage: ""
  }),
  actions: {
    async getOrdiniVenditaOdoo() {
      const { data, getData, loading, messageError } = useGetData();
      this.caricandoOrdiniVendita = true;
      await getData("/api/ordini_vendita");
      if (!messageError.value) {
        this.ordiniVendita = data.value;
        this.caricandoOrdiniVendita = loading.value;
      } else {
        this.errorMessage = messageError;
      }
    },
    async getOrdiniVenditaIncompletiOdoo() {
      const { data, getData, loading, messageError } = useGetData();
      this.caricandoOrdiniVendita = true;
      await getData("/api/ordini_vendita/ordini_incompleti");
      if (!messageError.value) {
        this.ordiniVendita = data.value;
        this.caricandoOrdiniVendita = loading.value;
      } else {
        this.errorMessage = messageError;
      }
    },
    async stampaOrdineVenditaOdoo(body) {
      const { data, postDataStream } = usePostDataFileStream();
      await postDataStream("/api/stampa_ordine_vendita", body);
      return data.value;
    }
  }
});
